import { useEffect, useState } from 'react'
import { generatePath, Link } from 'react-router-dom'
import { useRichiestaServer, useRoutes } from '@lucan/base-ui'
import { OPERAZIONI } from 'configuration/ConfigurazioneApi'
import { ASSETS, CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { useAppContext } from 'GlobalContext'
import { Box, Menu } from '@mui/material'

export default function BottoneSPID() {
  const { uri } = useAppContext()

  const { getPath } = useRoutes()
  const [idps, setIdps] = useState([])
  const {
    inviaOperazione,
  } = useRichiestaServer()

  useEffect(() => {

    async function fetchIdps() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.INTERMEDIARI_GET, null, {}, {
        headers: { uri } 
      })
      if(ok){
        setIdps(data.sort(() => Math.random() - 0.5))
      }else{
        setIdps([])
      }     
    }

    fetchIdps()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uri])

   const creaLinkAvvioSPID = (idpurl) => {
      const path = getPath(CHIAVI_ROUTES.AVVIO_SPID)
      return generatePath(path, { idpurl })
    }

    const [anchorEl, setAnchorEl] = useState(null)
    function apriMenu(e) {
      setAnchorEl(e.currentTarget)
    }

    function chiudiMenu() {
      setAnchorEl(null)
    }

     return (<>
     <Box onClick={apriMenu}className="italia-it-button italia-it-button-size-m button-spid"
        aria-haspopup="true">
      <span className="italia-it-button-icon">
          <img src={`${ASSETS}img/spid-ico-circle-bb.svg`} alt="" />
        </span>
        <span className="italia-it-button-text">
          Entra con SPID
        </span>
     </Box>
    <Menu
      disableScrollLock
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={chiudiMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: 'transparent', // sfondo trasparente
            boxShadow: 'none',              // rimuove l’ombra
          },
        },
      }}
     
    ><Box className="spid-idp-button spid-idp-button-tip spid-idp-button-relative"
      style={{ display: 'block', position:'relative'}}>
        <ul className="spid-idp-button-menu">
          {idps.map(idp => (
            <li
              key={idp.entity_id}
              className="spid-idp-button-link"
              data-idp={idp.entity_id}
            >
              <Link to={creaLinkAvvioSPID(idp.entity_id)}>
                <span className="spid-sr-only">
                  {idp.organization_name}
                </span>
                <img
                  style={{ height: 44 }}
                  src={`${ASSETS}img/${idp.logo_uri}`}
                  alt={idp.organization_name}
                />
              </Link >
            </li>
          ))}

          <li><a href="https://www.spid.gov.it">Maggiori informazioni</a></li>
          <li><a href="https://www.spid.gov.it/richiedi-spid">Non hai SPID?</a></li>
          <li><a href="https://www.spid.gov.it/serve-aiuto">Serve aiuto?</a></li>
        </ul>
      </Box>
    </Menu>
  </>
  )
}
